import { render } from "./EventsBox.vue?vue&type=template&id=606495c7"
import script from "./EventsBox.vue?vue&type=script&lang=js"
export * from "./EventsBox.vue?vue&type=script&lang=js"

import exportComponent from "/codebuild/output/src198257980/src/impact-vuejs/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__